import React from "react"

import type { TransientData } from "./types"

// Retired with the host binding: no hook reads it. Kept only so that
// components/ui/layout.tsx compiles until the composition task drops its
// provider.
export const HostPageContext = React.createContext<{
  transient: TransientData
}>({ transient: {} })
